import React, { useState, useEffect } from "react";
import { useLenis } from "./SmoothScroll";

export default function HipaaNotice() {
  const [lang, setLang] = useState("en");

  useEffect(() => {
    if (window.location.hash === "#es") setLang("es");
  }, []);
 const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, []);
  return (
    <>
      <title>HIPAA Compliance | Citrus Diagnostic Center Crystal River</title>
      <meta
        name="description"
        content="Citrus Diagnostic Center adheres to strict HIPAA compliance standards to protect patient privacy and ensure the secure handling of all medical imaging records."
      />

      <div className="xl:max-w-[1200px] md:w-4/5 w-11/12 mx-auto md:pt-60 pt-40 lg:pb-60 md:pb-32 pb-20 text-[#111] text-[17px] leading-relaxed font-sans">
        {/* Header */}
        <header className="flex items-center justify-center gap-3 border-b-4 border-[#d78558] pb-3">
          <div>
            <h1 className="m-0 md:text-5xl text-3xl pb-10 text-[#d78558] text-center font-bold">
              Notice of Privacy Practices (HIPAA)
            </h1>
            <p className="m-0 text-xl pb-8 text-center text-white">
              922 N. Citrus Avenue, Crystal River, FL 34428 • (352) 450-8062
            </p>
          </div>
        </header>

        {/* Language Toggle */}
        <nav className="sticky top-0 z-10  flex gap-2 md:px-40 py-4  mt-2">
          <button
           aria-label="English"
            onClick={() => {
              setLang("en");
              window.location.hash = "en";
            }}
            className={`flex-1 text-center border-2 border-[#d78558] px-3 py-2 rounded-lg font-bold text-[16px] ${
              lang === "en"
                ? "bg-[#d78558] text-white"
                : "bg-[#FEECE2]  text-[#d78558]"
            }`}
          >
            English
          </button>
          <button
           aria-label="Español"
            onClick={() => {
              setLang("es");
              window.location.hash = "es";
            }}
            className={`flex-1 text-center border-2 border-[#d78558] px-3 py-2 rounded-lg font-bold text-[16px] ${
              lang === "es"
                ? "bg-[#d78558] text-white"
                : "bg-[#FEECE2]  text-[#d78558]"
            }`}
          >
            Español
          </button>
        </nav>

        {/* Notice Meta */}
        <section className="bg-[#FEECE2] p-3 border-l-4 border-[#d78558] my-3 text-[15px]">
          <strong>Effective Date:</strong> January 1, 2025
          <br />
          How we may use/share your health information and how you can access
          it.
        </section>

        {/* English Content */}
        {lang === "en" && (
          <section lang="en">
            <h2 className=" text-[#ffffff] my-6 text-2xl  font-semibold">
              Your Rights
            </h2>
            <div className="grid md:grid-cols-2 gap-3">
              {[
                [
                  "Access & Copies",
                  "Get a paper or electronic copy of your medical record.",
                ],
                [
                  "Corrections",
                  "Ask us to correct information you think is wrong or incomplete.",
                ],
                [
                  "Confidential Communications",
                  "Request that we contact you at a different address or phone number.",
                ],
                [
                  "Restrictions",
                  "Ask for limits on how we use or share your information.",
                ],
                [
                  "Disclosures List",
                  "Receive a list of certain disclosures we’ve made.",
                ],
                ["Copy of this Notice", "Get a copy at any time."],
                ["Complaints", "File a complaint without fear of retaliation."],
              ].map(([title, desc], i) => (
                <div
                  key={i}
                  className="bg-[#FEECE2] border border-gray-200 border-l-4 border-l-[#d78558] p-3 rounded-md"
                >
                  <h3 className=" text-[#d78558] text-[18px] font-semibold">
                    {title}
                  </h3>
                  <p>{desc}</p>
                </div>
              ))}
            </div>

            <h2 className=" text-[#ffffff] my-6 text-2xl font-semibold">
              How We Use & Share Information
            </h2>
            <div className="bg-[#FEECE2] border border-gray-200 border-l-4 border-l-[#d78558] p-3 rounded-md">
              <p>
                <strong>Treatment</strong>, <strong>Payment</strong>, and{" "}
                <strong>Healthcare Operations</strong>. Also when required for
                public health & safety, oversight, law enforcement, court
                orders, organ/tissue donation, workers’ comp, and change of
                ownership.
              </p>
            </div>

            <div className="bg-[#FEECE2] border border-gray-200 border-l-4 border-l-[#d78558] p-3 rounded-md mt-3">
              <h3 className=" text-[#d78558] text-[18px] font-semibold">
                Other Uses Require Your Authorization
              </h3>
              <p>
                Marketing, selling your info, or psychotherapy notes (if
                applicable) require written permission. You may revoke at any
                time in writing.
              </p>
            </div>

            <h2 className=" text-[#ffffff] my-6 text-2xl font-semibold">
              Our Duties
            </h2>
            <div className="bg-[#FEECE2] border border-gray-200 border-l-4 border-l-[#d78558] p-3 rounded-md">
              <p>
                We must protect your PHI, provide this notice, follow it, and
                notify you of a breach within <strong>30 days (Florida)</strong>{" "}
                or 60 days (HIPAA), whichever is stricter.
              </p>
            </div>

            <h2 className=" text-[#ffffff] my-6 text-2xl font-semibold">
              Nondiscrimination
            </h2>
            <div className="bg-[#FEECE2] border border-gray-200 border-l-4 border-l-[#d78558] p-3 rounded-md">
              <p>
                No discrimination based on race, color, national origin, age,
                disability, sex, sexual orientation, gender identity, or ability
                to pay. Free language assistance and auxiliary aids available.
              </p>
            </div>

            <h2 className=" text-[#ffffff] my-6 text-2xl font-semibold">
              Questions or Complaints
            </h2>
            <div className="bg-[#FEECE2] border border-gray-200 border-l-4 border-l-[#d78558] p-3 rounded-md">
              <p>
                <strong>Privacy Officer:</strong> Samir K. Amin, M.D. •
                (352) 450-8062
                <br />
                922 N. Citrus Avenue, Crystal River, FL 34428
              </p>
              <p>
                HHS Office for Civil Rights: 1-800-368-1019 • OCRMail@hhs.gov •{" "}
                <a
                  href="https://ocrportal.hhs.gov/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-700 underline"
                >
                  ocrportal.hhs.gov
                </a>
              </p>
            </div>

            {/* Downloads */}
            <section className="bg-[#FEECE2] p-3 border-l-4 border-[#d78558] rounded-md mt-4">
              <strong>Downloads (English):</strong>
              <br />
              <a
                href="Citrus_Diagnostic_Center_Website_Policies.pdf"
                download
                className="block md:inline-block md:mr-3 text-[16px] underline"
              >
                Full Privacy Policy (PDF)
              </a>
              <a
                href="Citrus_Diagnostic_Center_Website_Policies.docx"
                download
                className="block md:inline-block md:mr-3 text-[16px] underline"
              >
                Full Privacy Policy (Word)
              </a>
              <a
                href="HIPAA_Privacy_Poster_Color.pdf"
                download
                className="block md:inline-block text-[16px] underline"
              >
                Poster Summary (PDF)
              </a>
            </section>
          </section>
        )}

        {/* Spanish Content */}
        {lang === "es" && (
          <section lang="es">
            <h2 className=" text-[#ffffff] my-6 text-2xl font-semibold">
              Sus Derechos
            </h2>
            <div className="grid md:grid-cols-2 gap-3">
              {[
                [
                  "Acceso y Copias",
                  "Obtenga una copia en papel o electrónica de su historial médico.",
                ],
                [
                  "Correcciones",
                  "Pida corregir información incorrecta o incompleta.",
                ],
                [
                  "Comunicaciones Confidenciales",
                  "Solicite contacto en otro número o dirección.",
                ],
                [
                  "Restricciones",
                  "Pida límites sobre cómo usamos o compartimos su información.",
                ],
                [
                  "Lista de Divulgaciones",
                  "Reciba una lista de ciertas divulgaciones.",
                ],
                ["Copia del Aviso", "Obtenga una copia en cualquier momento."],
                ["Quejas", "Presente una queja sin represalias."],
              ].map(([title, desc], i) => (
                <div
                  key={i}
                  className="bg-[#FEECE2] border border-gray-200 border-l-4 border-l-[#d78558] p-3 rounded-md"
                >
                  <h3 className=" text-[#d78558] text-[18px] font-semibold">
                    {title}
                  </h3>
                  <p>{desc}</p>
                </div>
              ))}
            </div>

            <h2 className=" text-[#ffffff] my-6 text-2xl font-semibold">
              Cómo Usamos y Compartimos su Información
            </h2>
            <div className="bg-[#FEECE2] border border-gray-200 border-l-4 border-l-[#d78558] p-3 rounded-md">
              <p>
                <strong>Tratamiento</strong>, <strong>Pago</strong> y{" "}
                <strong>Operaciones</strong>. También cuando la ley lo requiere
                para salud pública y seguridad, supervisión, cumplimiento de la
                ley, órdenes judiciales, donación de órganos/tejidos,
                compensación laboral y cambio de propiedad.
              </p>
            </div>

            <div className="bg-[#FEECE2] border border-gray-200 border-l-4 border-l-[#d78558] p-3 rounded-md mt-3">
              <h3 className=" text-[#d78558] text-[18px] font-semibold">
                Otros Usos con su Autorización
              </h3>
              <p>
                Marketing, venta de su información o notas de psicoterapia (si
                aplica) requieren permiso por escrito. Puede revocar por escrito
                en cualquier momento.
              </p>
            </div>

            <h2 className=" text-[#ffffff] my-6 text-2xl font-semibold">
              Nuestros Deberes
            </h2>
            <div className="bg-[#FEECE2] border border-gray-200 border-l-4 border-l-[#d78558] p-3 rounded-md">
              <p>
                Debemos proteger su PHI, proveer este aviso, cumplirlo y
                notificarle de un incumplimiento dentro de{" "}
                <strong>30 días (Florida)</strong> o 60 días (HIPAA), lo que sea
                más estricto.
              </p>
            </div>

            <h2 className=" text-[#ffffff] my-6 text-2xl font-semibold">
              No Discriminación
            </h2>
            <div className="bg-[#FEECE2] border border-gray-200 border-l-4 border-l-[#d78558] p-3 rounded-md">
              <p>
                No discriminamos por raza, color, origen, edad, discapacidad,
                sexo, orientación sexual, identidad de género ni capacidad de
                pago. Ayuda de idioma y ayudas auxiliares gratis.
              </p>
            </div>

            <h2 className=" text-[#ffffff] my-6 text-2xl font-semibold">
              Preguntas o Quejas
            </h2>
            <div className="bg-[#FEECE2] border border-gray-200 border-l-4 border-l-[#d78558] p-3 rounded-md">
              <p>
                <strong>Oficial de Privacidad:</strong> Samir K. Amin, M.D. •
                (352) 450-8062
                <br />
                922 N. Citrus Avenue, Crystal River, FL 34428
              </p>
              <p>
                HHS - Oficina de Derechos Civiles: 1-800-368-1019 •
                OCRMail@hhs.gov •{" "}
                <a
                  href="https://ocrportal.hhs.gov/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-700 underline"
                >
                  ocrportal.hhs.gov
                </a>
              </p>
            </div>

            {/* Downloads */}
            <section className="bg-[#FEECE2] p-3 border-l-4 border-[#d78558] rounded-md mt-4">
              <strong>Descargas (Español):</strong>
              <br />
              <a
                href="Citrus_Diagnostic_Center_Website_Policies.pdf"
                download
                className="block md:inline-block md:mr-3 text-[16px] underline"
              >
                Aviso Completo (PDF)
              </a>
              <a
                href="Citrus_Diagnostic_Center_Website_Policies.docx"
                download
                className="block md:inline-block md:mr-3 text-[16px] underline"
              >
                Aviso Completo (Word)
              </a>
              <a
                href="HIPAA_Privacy_Poster_Summary_ES.pdf"
                download
                className="block md:inline-block text-[16px] underline"
              >
                Resumen del Póster (PDF)
              </a>
            </section>
          </section>
        )}

        <footer className="mt-7 py-4 border-t-4 text-xl border-[#d78558]  text-white">
          <em>
            HIPAA Notice of Privacy Practices. Provided for patient education
            and compliance with federal HIPAA and Florida law.
          </em>
        </footer>
      </div>
    </>
  );
}
